/* Spalvos -> nuotraukos žemėlapis prekėms, kurių variantai Shopify neturi
   priskirtų nuotraukų. Raktas: prekės handle; vidinis raktas: normalizuota
   spalva (be diakritikų, mažosiomis); reikšmės: failo vardai iš Shopify CDN. */
window.mimuColorImages = {
  "pliusinis-veliurinis-kostiumas": {
    "zydra": ["1.jpg", "2.jpg", "3.jpg", "4.jpg", "5.jpg"],
    "rozine": ["A227E88A-DF53-4FBF-8682-9ED6EEA9F5AE.jpg", "A12D9A22-C94D-486B-8F80-DAD5D9672BF9.jpg", "B6DB2771-5167-4E40-84A9-A3A3971A8EA6.jpg"],
    "pilka": ["9A9CBF28-8B77-4D34-AAA8-3732DE8D2D06.jpg", "0614754A-2862-425C-8D01-5E84D87E49A8.jpg", "A2B412FE-949A-4C49-918F-42244CDBD5AE.jpg", "C85E49E7-DCAE-4626-B67F-1BA550EA3A99.jpg", "05780019-0AE6-4C5A-8EC8-F9F1EE021782.jpg"],
    "biezine": ["FCA28153-385E-47BE-A4B7-25F0424E0299.jpg", "9F002095-4D63-46AC-9E1E-69D04E01C211.jpg", "617C0DEB-09A4-4F22-A73A-AD19DD733A09.jpg"]
  },
  "veliurinis-kostiumas-trumpintas-dzemperis-placios-kelnes": {
    "rozine": ["rozine1.jpg", "rozine2.jpg"],
    "ryskiai melyna": ["melyna1.jpg", "melyna2.jpg"],
    "sviesiai melyna": ["sviesiai-melyna.jpg"],
    "sokoladine": ["IMG_7119.jpg"]
  },
  "veliurines-laisvalaikio-kelnes": {
    "sviesiai pilka": ["IMG_6368.jpg", "IMG_6369.jpg", "IMG_6370.jpg"],
    "sokoladine": ["IMG_6374.jpg"],
    "tamsiai pilka": ["IMG_6372.jpg", "IMG_6371.jpg"]
  },
  "madingos-oversize-kelnes-su-juostelemis-ir-atsegamais-sonais": {
    "pilka": ["IMG_6224.jpg", "IMG_6223.jpg", "IMG_6225.jpg"],
    "juoda": ["IMG_6218.jpg", "IMG_6219.jpg", "IMG_6222.jpg"]
  },
  "dzinsinis-kombinezonas": {
    "zydra": ["IMG_6908.jpg", "IMG_6909.jpg"],
    "smeline": ["ChatGPTImageAug20_2026_08_55_10PM.png", "ChatGPTImageAug20_2026_08_53_42PM.png"]
  },
  "veliurinis-kostiumelis": {
    "balta": ["B28B25A2-19F2-448C-9C3E-C77A96F6B8AA.jpg", "7F0FD4D4-F100-4632-A4A0-293832ADC2F8.jpg", "3180DA24-870B-48A5-ADE5-A256E7146D7F.jpg"],
    "sokoladine": ["E31A2920-15E1-480A-A388-49188E694A5D.jpg", "4B4BF9C6-950F-43B1-B37F-AF201105CAD2.jpg"]
  },
  "triju-daliu-kostiumelis": {
    "rozine": ["IMG_6228.jpg", "IMG_6229.jpg"],
    "sokoladine": ["IMG_6226.jpg", "IMG_6227.jpg"]
  },
  "laisvalaikio-kostiumas-striuke-ir-kelnes": {
    "tamsiai melyna": ["IMG_6381.jpg", "IMG_6378.jpg"],
    "juoda": ["IMG_6377.jpg", "IMG_6379.jpg"]
  },
  "velurinis-kostiumas": {
    "smaragdine": ["IMG_6964.jpg", "IMG_6963.jpg"],
    "pilka": ["IMG_6960.jpg", "IMG_6961.jpg"],
    "mokko": ["IMG_6958.jpg", "IMG_6959.jpg"]
  },
  "veliurines-kelnes": {
    "juoda": ["IMG_6967.jpg"],
    "sokoladine": ["IMG_6966.jpg", "IMG_6970.jpg", "IMG_6969.jpg"]
  },
  "zomsinis-svarkas": {
    "karameline": ["IMG_6769.jpg", "IMG_6771.jpg", "IMG_6772.jpg"],
    "sokoladine": ["IMG_6774.jpg", "IMG_6773.jpg", "IMG_6775.jpg"],
    "juoda": ["IMG_7117.jpg", "IMG_7118.jpg", "IMG_7116.jpg"]
  },
  "kasmyrinio-trikotazo-kostiumelis": {
    "pieno": ["865B96C0-89BD-4079-9A98-703F0E6C0A53.jpg", "F674AB11-2780-4B57-9E62-5687633B0673.jpg", "BE54CA19-0413-407C-BA82-66E51CD4787B.jpg"],
    "juoda": ["0ECE863D-2284-4C57-92E7-4209785B65EE.jpg", "22A005BD-F049-421A-AB7F-061E85F63823.jpg", "3BB12017-E02C-4CBF-8E2B-4714F5D76AA0.jpg"],
    "sokoladine": ["BE317249-9025-4C77-A86C-3ABEB3F87028.jpg", "0EC75421-B160-43A3-97E0-43324E2CEE2A.jpg", "08B0947A-863F-4AFD-BC05-B6A71D35F728.jpg"]
  },
  "veliurinis-kombinezonas": {
    "pieno": ["IMG_6800_063169a1-071c-44e4-961a-e832a1002165.jpg", "IMG_6797_2ce314bb-1a9a-42cd-93e4-a060365bdc57.jpg"],
    "rozine": ["IMG_6794_e021ff68-dd19-4672-b214-b55187122a3d.jpg", "IMG_6795_54790185-264a-4f0e-bc5b-cc25dc6706d9.jpg"],
    "juoda": ["IMG_6796_b98fad33-8aef-4636-b1fe-0e8bd481c16b.jpg", "IMG_6799_d147a71d-59b7-4ba5-9eb2-d3b51110f5b3.jpg"]
  },
  "languoti-marskiniai": {
    "zydrai balta": ["IMG_6863.jpg", "IMG_6861.jpg", "IMG_6862.jpg"],
    "pilkai melyna": ["IMG_6854.jpg", "IMG_6853.jpg", "IMG_6859.jpg"],
    "melynai ruda": ["IMG_6858.jpg", "IMG_6860.jpg"],
    "ruda": ["IMG_6865.jpg", "IMG_6864.jpg", "IMG_6866.jpg"],
    "rozine/balta": ["IMG_6856.jpg", "IMG_6857.jpg", "IMG_6855.jpg"]
  },
  "pailginti-marskiniai-su-langeliais-korsetas": {
    "juoda": ["IMG_6874.jpg", "IMG_6875.jpg", "IMG_6873.jpg"],
    "ruda": ["IMG_6871.jpg", "IMG_6870.jpg", "IMG_6869.jpg", "IMG_6872.jpg"]
  },
  "kostiumas-dvieju-daliu": {
    "rozine": ["IMG_6890.jpg", "IMG_6888.jpg", "IMG_6889.jpg"],
    "smeline": ["IMG_6891.jpg", "IMG_6893.jpg"]
  },
  "laisvalaikio-kelnes": {
    "pilka su rozinemis juostelemis": ["IMG_6904.jpg", "IMG_6903.jpg"],
    "sokoladine": ["IMG_6900.jpg", "IMG_6899.jpg"],
    "pilka su juodomis juostelemis": ["IMG_6902.jpg", "IMG_6901.jpg"]
  },
  "lengva-striuke": {
    "rozine": ["IMG_7067.jpg", "IMG_7064.jpg"],
    "pilka": ["IMG_7065.jpg", "IMG_7066.jpg"]
  },
  "stilingas-bomberis-svarkelis": {
    "sokoladine": ["IMG_7077.jpg", "IMG_7078.jpg"],
    "pilka": ["IMG_7075.jpg", "IMG_7076.jpg"]
  },
  "stilingas-trumpas-lietpaltis-su-pamusalu": {
    "tamsiai pilka": ["IMG_7082.jpg"],
    "pieno": ["IMG_7081.jpg"]
  },
  "dvieju-daliu-laisvalaikio-kostiumelis": {
    "pieno": ["IMG_7084.jpg", "IMG_7083.jpg"],
    "smeline": ["IMG_7062.jpg", "IMG_7086.jpg"]
  }
};
